class CollectionUtil {

    static singleSort(property: string) {
        let sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a: any, b: any) {

            let _a: any = a, _b: any = b;

            if (String(a).replace(/\d/g, "") === "") {
                _a = Number(_a)
            }

            if (String(a).replace(/\d/g, "") === "") {
                _b = Number(_b)
            }

            let result = (_a[property] < _b[property]) ? -1 : (_a[property] > _b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    }

    static muiltiSort(...args: any[]) {
        var props = args.filter((p) => p !== null);
        return function (obj1: any, obj2: any) {
            var i = 0, result = 0, numberOfProperties = props.length;
            while (result === 0 && i < numberOfProperties) {
                result = CollectionUtil.singleSort(props[i])(obj1, obj2);
                i++;
            }
            return result;
        }
    }

    static reorder = <T>(
        list: T[],
        startIndex: number,
        endIndex: number
    ): T[] => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    static areEquals(...args: any[]): boolean {
        const argsList: string[] = [];
        for (let arg of args) {
            argsList.push(btoa(JSON.stringify(arg)))
        }
        if (argsList.every((a, i, argsList) => {
            const toCompare: boolean[] = []
            for (let _a of argsList) {
                toCompare.push(_a === a);
            }
            return toCompare.every(Boolean)
        })) {
            return true;
        }
        return false
    };

    static merge<T = any>(target: any, source: any): T {
        const oldTarget = Object.assign({}, target);
        return Object.assign(oldTarget, source);
    }

}

export { CollectionUtil };

